import { isCSR, getDistributor } from '@raisin/cp-utils';

export const COUNTRY_CODE = '%countryCode%';
export const LOCALE = '%locale%';
export const UNDERSCORE_LOCALE = '%underscoreLocale%';
export const DISTRIBUTOR_ID = getDistributor();
export const DISTRIBUTION_CHANNEL_ID_RAISIN = '%distributionChannel%';

const apiRoutes = {
  production: {
    wjis: {
      offers: `/offers/${COUNTRY_CODE}/retail?locale=${UNDERSCORE_LOCALE}`,
      referAFriendId: '/refer-a-friend/id/generate/:bac_number',
      trustpilotVerifiedReview: '/trustpilot/verified-review',
    },
    dbs: {
      products: '/public/products',
      banks: '/public/banks',
      bankDetails: '/public/banks/:bankId',
      productsAccess: '/products/types',
      privateProducts: '/products',
    },
    obs: {
      productReplatformingStatus: '/replatforming/products/:productID/status',
    },
    varify: {
      products: '/pos-public',
      productTerms: '/pos-public',
    },
  },
  local: {
    wjis: {
      offers: `/offers_endpoint_${LOCALE}.json`,
      referAFriendId: '/refer_a_friend.json',
      trustpilotVerifiedReview: '/trustpilot_verified_review.json',
    },
    dbs: {
      products: '/products.json',
      banks: '/banksList.json',
      bankDetails: '/bankDetails.json',
      productsAccess: '/productsAccess.json',
      privateProducts: '/privateProducts.json',
    },
    obs: {
      productReplatformingStatus: '/productReplatformingStatus.json',
    },
    varify: {
      products: '/pos-public.json',
      productTerms: '/pos-public-terms.json',
    },
  },
};

if (
  process.env.NODE_ENV === 'development' ||
  (isCSR() && window.location.hostname === 'localhost')
) {
  apiRoutes.production = {
    wjis: {
      offers: `/${COUNTRY_CODE}/v1/offers/${COUNTRY_CODE}/retail?locale=${UNDERSCORE_LOCALE}`,
      referAFriendId: `/${COUNTRY_CODE}/v1/refer-a-friend/id/generate/:bac_number`,
      trustpilotVerifiedReview: `/${COUNTRY_CODE}/v1/trustpilot/verified-review`,
    },
    dbs: {
      products: '/public/products',
      banks: '/public/banks',
      bankDetails: '/public/banks/:bankId',
      productsAccess: `/products/types?country_code=${COUNTRY_CODE}`,
      privateProducts: '/products',
    },
    obs: {
      productReplatformingStatus: '/replatforming/products/:productID/status',
    },
    varify: {
      products: '/pos-public',
      productTerms: '/pos-public',
    },
  };
}

export default apiRoutes;
